<div class="content-with-stepper-and-title">
    <main>
        <div class="row">
            <div class="field col-12 col-pr-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <ul class="dashed">
                    <li [innerHtml]="copyService.copies.document_requirements.requirement_list.first_point"></li>
                    <li [innerHtml]="copyService.copies.document_requirements.requirement_list.second_point"></li>
                    <li [innerHtml]="copyService.copies.document_requirements.requirement_list.third_point"></li>
                </ul><br/>
                <h1 [innerHtml]="copyService.copies.document_requirements.additional_requirements"></h1><br/>
            </div>
        </div>

        <div class="mt-2">
            <vcl-accordion-group>
                <vcl-accordion *ngFor="let document of requirementsList" [accordionTitle]="document.name" isOpened="false">
                    <div class="row m-3" *ngIf="document.isSegmentent">
                        <div *ngFor="let item of document.requirements">
                            <h1 [innerHtml]="item.title"></h1>
                            <ul class="dashed">
                                <li *ngFor="let description of item.descriptions" class="width-xbold small-letter">{{description}}</li>
                            </ul><br/>
                        </div>
                    </div>
                    <div class="row m-3" *ngIf="!document.isSegmentent">
                        <ul class="dashed">
                            <li *ngFor="let element of document.requirements" class="width-xbold small-letter">{{element}}</li>
                        </ul>
                    </div>
                </vcl-accordion>
            </vcl-accordion-group>
        </div>
    
    </main>
    <app-controls class="mt-4 button-back" [hasPrevious]="false" [nextLabel]="copyService.copies.document_requirements.back_button" (next)="next(200)"></app-controls>
</div>
  